module.exports = __webpack_public_path__ + "img/umbrella.3bf744f4.svg";